import { createBidirectionalMap } from './bidirectionalMap';
import type { ProjectType } from './types.generated';

export const projectTypeMap = createBidirectionalMap<ProjectType>()({
  STANDARD: 'standard',
  SERVICE: 'service',
});
